if (!customElements.get('ksl-size-guide')) {
  customElements.define('ksl-size-guide', class extends HTMLElement {
    connectedCallback() {
      if (this.dialog || typeof HTMLDialogElement === 'undefined') return;
      const summary = this.querySelector('summary');
      const content = this.querySelector('[data-size-content]');
      if (!summary || !content) return;
      this.dialog = document.createElement('dialog');
      this.dialog.className = 'ksl-size ksl-size__dialog';
      this.dialog.setAttribute('aria-label', summary.textContent.trim());
      this.dialog.append(content);
      this.append(this.dialog);
      summary.setAttribute('role', 'button');
      summary.setAttribute('aria-haspopup', 'dialog');
      const close = content.querySelector('[data-size-close]');
      close.hidden = false;
      summary.addEventListener('click', (event) => {
        event.preventDefault();
        const scope = document.getElementById(`shopify-section-${this.dataset.sectionId}`) || this.parentElement;
        const values = [...scope.querySelectorAll('select, input:checked')].map((input) => input.value.trim().toLowerCase());
        content.querySelectorAll('[data-size-value]').forEach((row) => row.toggleAttribute('data-selected', values.includes(row.dataset.sizeValue.trim().toLowerCase())));
        this.lockedScroll = !document.body.classList.contains('overflow-hidden');
        if (this.lockedScroll) document.body.classList.add('overflow-hidden');
        this.dialog.showModal();
      });
      close.addEventListener('click', () => this.dialog.close());
      this.dialog.addEventListener('close', () => {
        if (this.lockedScroll) document.body.classList.remove('overflow-hidden');
        (this.returnFocus?.isConnected ? this.returnFocus : summary).focus();
        this.returnFocus = null;
      });
      this.dialog.addEventListener('click', (event) => {
        if (event.target !== this.dialog) return;
        const bounds = this.dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) this.dialog.close();
      });
    }
    disconnectedCallback() { if (this.dialog?.open) this.dialog.close(); }
  });
}
